const apiUrl = process.env.REACT_APP_API_URL;

const getModulesByAssetID = (token, id, cb) => {
    fetch(`${apiUrl}/GetModulesByAssetID/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getModulesByAssetID;
